module.exports = __webpack_public_path__ + "static/media/teltonika-fm5500-7.6dcd9728.jpg";